angular.
module("dx.webapp.clientVersion", [
	"dx.webapp.datetimeinput",
]);
